<template>
  <el-dialog
    id="approvalDialog"
    title="审批单据"
    :visible="true"
    width="500px"
    @close="closeDialog"
    v-if="dialogVisible"
  >
    <el-form
      :model="approvalInfo"
      label-position="right"
      label-width="100px"
      ref="approvalFormRef"
      :rules="{
        handleMessage: $ruleUtil.simple({
          fieldName: '审批意见',
          required: true,
          max: 200,
        }),
      }"
      v-if="orderInfo"
    >
      <el-form-item label="单号">
        {{ orderInfo.orderNo }}
      </el-form-item>
      <el-form-item label="审批结果">
        <el-radio-group v-model="approvalInfo.agree">
          <el-radio :label="true">
            <span v-fmtype="'success'">审批通过</span>
          </el-radio>
          <el-radio :label="false">
            <span v-fmtype="'danger'">审批拒绝</span>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审批意见" prop="handleMessage">
        <el-input
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6 }"
          v-model="approvalInfo.handleMessage"
          placeholder="请输入审批意见"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button
        :type="approvalInfo.agree ? 'success' : 'danger'"
        @click="approval"
      >
        {{ approvalInfo.agree ? "确认通过" : "确认拒绝" }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "Fmerpv2WebOrderApprovalDialog",
  props: {
    orderInfo: {
      type: [Object],
      default: null,
    },
    orderName: [String],
    dialogVisible: [Boolean],
  },
  watch: {
    "approvalInfo.agree": {
      handler(newVal, val) {
        if (this.dialogVisible) {
          setTimeout(() => {
            if (newVal && !this.approvalInfo.handleMessage) {
              this.$message({
                message: "已为您自动填充审批意见，请根据需要修改或重新填写",
                type: "warning",
              });
              this.approvalInfo.handleMessage = "审批通过";
            } else if (
              !newVal &&
              this.approvalInfo.handleMessage == "审批通过"
            ) {
              this.approvalInfo.handleMessage = "";
            }
          }, 10);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      approvalInfo: {
        id: null,
        agree: true,
        handleMessage: null,
      },
    };
  },

  mounted() {},

  methods: {
    closeDialog() {
      this.$emit("close");
    },
    async approval() {
      this.$refs.approvalFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        this.approvalInfo.id = this.orderInfo.id;
        let resultRes = await this.$api[this.orderName + "_approval"](
          this.approvalInfo,
          {
            showLoading: true,
            loadingParam: {
              target: "#approvalDialog > *",
              lock: true,
            },
          }
        );
        if (resultRes && resultRes.success) {
          this.closeDialog();
        }
      });
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/OrderApprovalDialog.vue